
import React from "react";
import { Button } from "@/components/ui/button";
import { ButtonColorful } from "@/components/ui/button-colorful";
import { Save } from "lucide-react";

type ActionButtonsProps = {
  onSave: () => void;
  onContinue: () => void;
  isSaving: boolean;
};

export const ActionButtons = ({ onSave, onContinue, isSaving }: ActionButtonsProps) => {
  return (
    <div className="flex justify-between w-full">
      <Button
        variant="outline"
        onClick={onSave}
        disabled={isSaving}
      >
        {isSaving ? (
          <>
            <span className="animate-spin mr-2">◌</span>
            Saving...
          </>
        ) : (
          <>
            <Save className="mr-2 h-4 w-4" />
            Save Details
          </>
        )}
      </Button>
      
      <ButtonColorful 
        label="Continue to Program"
        onClick={onContinue}
      />
    </div>
  );
};
